module.exports = __webpack_public_path__ + "img/merchandise.8c31ea1e.svg";